// before 20-5-2026

// import React, { useEffect, useState, useMemo } from 'react';
// import { Card, Col, Container, Row, ProgressBar, Spinner } from 'react-bootstrap';
// import { useDispatch, useSelector } from 'react-redux';
// import { Link, useNavigate } from 'react-router-dom';
// import {
//   AccessibilityNew as AccessibilityNewIcon,
//   TipsAndUpdates as TipsAndUpdatesIcon,
//   Bookmark as BookmarkIcon,
//   AccessTimeFilled as AccessTimeFilledIcon,
//   AccessAlarm as AccessAlarmIcon,
//   TaskAlt as TaskAltIcon,
//   PhonelinkErase as PhonelinkEraseIcon,
//   ThumbUp as ThumbUpIcon,
//   Cancel as CancelIcon,
//   WorkHistory as WorkHistoryIcon,
//   Backspace as BackspaceIcon,
//   ArrowForward as ArrowForwardIcon,
//   ShowChart as ShowChartIcon,
//   TrendingUp as TrendingUpIcon,
//   People as PeopleIcon,
//   Dashboard as DashboardIcon,
//   BarChart as BarChartIcon,
//   Celebration as CelebrationIcon,
//   PendingActions as PendingActionsIcon,
//   ArrowBack as ArrowBackIcon,
// } from '@mui/icons-material';
// import { Doughnut } from 'react-chartjs-2';
// import {
//   Chart as ChartJS,
//   ArcElement,
//   Tooltip,
//   Legend,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   Title,
//   Filler,
// } from 'chart.js';
// import LinearProgress from '@mui/material/LinearProgress';
// import Box from '@mui/material/Box';
// import Button from '@mui/material/Button';
// import CircularProgress from '@mui/material/CircularProgress';
// import { useTheme } from '@mui/material';
// import { GetteamleaderdashboarddatabyteamleaderemailadvancedCRMDATA } from '../../Redux/Actions/RoleData_Actions';

// // Register ChartJS components
// ChartJS.register(
//   ArcElement,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   Title,
//   Tooltip,
//   Legend,
//   Filler,
// );

// export const TeamLeaderQuickNumbersCRMData = () => {
//   const theme = useTheme();
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   const mode = theme.palette.mode;

//   const [userlogin, setUserLogin] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [dataLoading, setDataLoading] = useState(false);

//   useEffect(() => {
//     const user = JSON.parse(localStorage.getItem('user'));
//     if (user) setUserLogin(user);
//   }, []);

//   // تعريف الأيقونات مع ألوان موحدة
//   const stagesIcons = {
//     Fresh: <TipsAndUpdatesIcon fontSize="large" />,
//     'No Stage': <TipsAndUpdatesIcon fontSize="large" />,
//     'Team Leader Fresh': <TipsAndUpdatesIcon fontSize="large" />,
//     'Team Leader Pending': <PendingActionsIcon fontSize="large" />,
//     Pending: <PendingActionsIcon fontSize="large" />,
//     Follow: <BookmarkIcon fontSize="large" />,
//     'Follow Up': <BookmarkIcon fontSize="large" />,
//     'Long Follow': <BookmarkIcon fontSize="large" />,
//     Transfer: <BackspaceIcon fontSize="large" />,
//     Interested: <ThumbUpIcon fontSize="large" />,
//     'Not Interested': <BackspaceIcon fontSize="large" />,
//     Meeting: <AccessTimeFilledIcon fontSize="large" />,
//     'Following After Meeting': <WorkHistoryIcon fontSize="large" />,
//     'Follow After Meeting': <WorkHistoryIcon fontSize="large" />,
//     'Cancel Meeting': <CancelIcon fontSize="large" />,
//     'Done Deal': <TaskAltIcon fontSize="large" />,
//     'No Answer': <PhonelinkEraseIcon fontSize="large" />,
//     'No Answer 1st Call': <AccessAlarmIcon fontSize="large" />,
//     Cancellation: <CancelIcon fontSize="large" />,
//   };

//   // ✅ استدعاء API الجديد مع إضافة فلتر CRM Data
//   const fetchDashboardData = async () => {
//     try {
//       setDataLoading(true);

//       if (userlogin?.data?.email) {
//         await dispatch(
//           GetteamleaderdashboarddatabyteamleaderemailadvancedCRMDATA(userlogin.data.email),
//         );
//         setDataLoading(false);
//       }
//     } catch (error) {
//       console.error('Error fetching CRM dashboard data:', error);
//       setDataLoading(false);
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (userlogin?.data?.email) {
//       setLoading(true);
//       fetchDashboardData();
//     }
//   }, [userlogin]);

//   // ✅ تصحيح استخراج البيانات من الـredux store
//   const dashboardData = useSelector((state) => state.AllRoleData.teamleaderdashboardcrmdata);

//   // ✅ البيانات تأتي في dashboardData.data.data لأن الـAPI يرجع {success: true, data: {...}}
//   const dashboard = dashboardData?.data?.dashboard || [];
//   const teamLeaderFresh = dashboardData?.data?.teamLeaderFresh || { leadsCount: 0 };
//   const teamLeaderPending = dashboardData?.data?.teamLeaderPending || {
//     leadsCount: 0,
//     salesIds: [],
//   };
//   const summary = dashboardData?.data?.summary || { totalLeads: 0 };
//   const teamleaderInfo = dashboardData?.data?.teamleaderInfo || {};

//   // ✅ تحديث حالة التحميل عندما تكون البيانات متوفرة
//   useEffect(() => {
//     if (dashboardData && !dataLoading) {
//       setLoading(false);
//     }
//   }, [dashboardData, dataLoading]);

//   // ✅ عرض بيانات التصحيح في الكونسول
//   useEffect(() => {
//     if (dashboardData && !loading) {
//       console.log('📊 CRM Dashboard data structure:', {
//         fullData: dashboardData,
//         hasData: !!dashboardData.data,
//         dashboardLength: dashboard.length,
//         freshCount: teamLeaderFresh.leadsCount,
//         pendingCount: teamLeaderPending.leadsCount,
//         totalLeads: summary.totalLeads,
//         note: 'Filtered with data=false & transferefromdata=false',
//       });
//     }
//   }, [dashboardData, loading]);

//   // ✅ دالة لترتيب الـ Stages حسب الترتيب المطلوب
//   const getSortedStages = (stages) => {
//     const order = [
//       'Team Leader Pending',
//       'Team Leader Fresh',
//       'No Stage',
//       'Pending',
//       'Interested',
//       'Follow Up',
//       'Meeting',
//       'Follow After Meeting',
//       'Done Deal',
//       'Cancel Meeting',
//       'No Answer',
//       'Not Interested',
//       'Transfer',
//       'Long Follow',
//       'Follow',
//       'Following After Meeting',
//       'No Answer 1st Call',
//       'Cancellation',
//     ];

//     // فلترة: إخفاء Fresh الأصلي إذا كان موجوداً في dashboard العادية
//     const filteredStages = stages.filter(
//       (stage) =>
//         stage.stageName !== 'Fresh' &&
//         stage.stageName !== 'Team Leader Fresh' &&
//         stage.stageName !== 'Team Leader Pending',
//     );

//     return [...filteredStages].sort((a, b) => {
//       const indexA = order.indexOf(a.stageName);
//       const indexB = order.indexOf(b.stageName);

//       if (indexA !== -1 && indexB !== -1) {
//         return indexA - indexB;
//       }

//       if (indexA !== -1) return -1;
//       if (indexB !== -1) return 1;

//       return 0;
//     });
//   };

//   // ✅ إضافة المراحل الخاصة للـdashboard بالترتيب المطلوب
//   const allStages = useMemo(() => {
//     let stages = [...dashboard];

//     // فلترة: إخفاء Fresh الأصلي
//     stages = stages.filter((stage) => stage.stageName !== 'Fresh');

//     // إضافة المراحل الخاصة بالترتيب المطلوب
//     const specialStages = [];

//     // 1. Team Leader Pending أولاً
//     if (teamLeaderPending.leadsCount > 0 || true) {
//       specialStages.push({
//         stageId: teamLeaderPending.stageId || 'team-leader-pending',
//         stageName: 'Team Leader Pending',
//         leadsCount: teamLeaderPending.leadsCount,
//         isTeamLeaderPending: true,
//         salesIds: teamLeaderPending.salesIds || [],
//       });
//     }

//     // 2. Team Leader Fresh ثانياً
//     if (teamLeaderFresh.leadsCount > 0 || true) {
//       specialStages.push({
//         stageId: teamLeaderFresh.stageId || 'team-leader-fresh',
//         stageName: 'Team Leader Fresh',
//         leadsCount: teamLeaderFresh.leadsCount,
//         isTeamLeaderFresh: true,
//       });
//     }

//     // 3. المراحل العادية بعد ذلك
//     const regularStages = getSortedStages(stages);

//     return [...specialStages, ...regularStages];
//   }, [dashboard, teamLeaderFresh, teamLeaderPending]);

//   // ✅ حساب إجمالي الـ Leads
//   const totalLeads = summary.totalLeads || 0;

//   // ✅ دالة التعامل مع النقر على مرحلة (معدلة لـ CRM Data)
//   const handleStageClick = async (stage) => {
//     const { stageName, isTeamLeaderFresh, isTeamLeaderPending, salesIds } = stage;

//     console.log('🎯 CRM Stage clicked:', stageName);

//     // 🔥 تنظيف جميع الـ localStorage القديم أولاً
//     const allKeysToRemove = [
//       'teamLeaderFreshMode',
//       'teamLeaderPendingMode',
//       'teamLeaderPendingSalesId',
//       'teamleaderfresh',
//       'teamleaderId',
//       'filterForSales',
//       'teamleaderpending',
//       'stagestorage',
//       'FilteredLeadsForNoStage',
//       'FilteredLeadsForTeamLeaderPending',
//       'freshFilterType',
//     ];

//     allKeysToRemove.forEach((key) => localStorage.removeItem(key));

//     // 🔥 إضافة معلمات CRM Data للجميع
//     const crmParams = {
//       data: 'true',
//       transferefromdata: 'false',
//     };

//     if (isTeamLeaderFresh) {
//       try {
//         const teamLeaderId =
//           teamLeaderPending.salesIds?.[0] || teamleaderInfo._id || userlogin?.data?._id || '';

//         console.log('✅ CRM Team Leader Fresh ID:', teamLeaderId);

//         if (!teamLeaderId) {
//           console.error('❌ User ID not found');
//           alert('Unable to identify team leader. Please log in again.');
//           return;
//         }

//         // 🔥 بناء query parameters مع إضافة CRM Data
//         const queryParams = new URLSearchParams({
//           stage: 'No Stage',
//           sales: teamLeaderId,
//           teamleaderfresh: 'true',
//           freshmode: 'teamleader',
//           ...crmParams, // 🔥 إضافة معلمات CRM Data
//         });

//         console.log('📤 CRM Fresh query params:', queryParams.toString());

//         // تخزين المعلومات
//         localStorage.setItem('stagestorage', 'No Stage');
//         localStorage.setItem('filterForSales', teamLeaderId);
//         localStorage.setItem('teamleaderId', teamLeaderId);
//         localStorage.setItem('teamleaderfresh', 'true');
//         localStorage.setItem('teamLeaderFreshMode', 'true');
//         localStorage.setItem('freshFilterType', 'teamleader');

//         // 🔥 إضافة علامة CRM Data
//         localStorage.setItem('crmDataMode', 'true');

//         navigate(`/TeamLeaderCRMDATAALLLeads?${queryParams.toString()}`);
//       } catch (error) {
//         console.error('❌ Error in CRM Fresh navigation:', error);

//         // Fallback
//         localStorage.setItem('stagestorage', 'No Stage');
//         localStorage.setItem('teamleaderfresh', 'true');
//         localStorage.setItem('teamLeaderFreshMode', 'true');
//         localStorage.setItem('crmDataMode', 'true');

//         navigate(
//           `/TeamLeaderCRMDATAALLLeads?stage=No Stage&teamleaderfresh=true&data=false&transferefromdata=false`,
//         );
//       }
//     } else if (isTeamLeaderPending) {
//       const teamLeaderId =
//         teamLeaderPending.salesIds?.[0] || teamleaderInfo._id || userlogin?.data?._id || '';

//       console.log('✅ CRM Team Leader Pending ID:', teamLeaderId);

//       // تنظيف أولاً
//       allKeysToRemove.forEach((key) => localStorage.removeItem(key));

//       // تعيين القيم الجديدة
//       localStorage.setItem('stagestorage', 'Pending');
//       localStorage.setItem('teamleaderpending', 'true');
//       localStorage.setItem('filterForSales', teamLeaderId);
//       localStorage.setItem('teamLeaderPendingMode', 'true');
//       localStorage.setItem('teamLeaderPendingSalesId', teamLeaderId);
//       localStorage.setItem('crmDataMode', 'true');

//       const queryParams = new URLSearchParams({
//         stage: 'Pending',
//         sales: teamLeaderId,
//         teamleaderpending: 'true',
//         pendingmode: 'teamleader',
//         ...crmParams, // 🔥 إضافة معلمات CRM Data
//       });

//       console.log('📤 CRM Pending query params:', queryParams.toString());

//       navigate(`/TeamLeaderCRMDATAALLLeads?${queryParams.toString()}`);
//     } else if (stageName === 'All Leads') {
//       // تنظيف شامل
//       allKeysToRemove.forEach((key) => localStorage.removeItem(key));
//       localStorage.setItem('stagestorage', '');
//       localStorage.setItem('crmDataMode', 'true');

//       // 🔥 إضافة CRM Data parameters للـ All Leads
//       const queryParams = new URLSearchParams({
//         ...crmParams,
//       });

//       navigate(`/TeamLeaderCRMDATAALLLeads?${queryParams.toString()}`);
//     } else {
//       // المراحل العادية
//       allKeysToRemove.forEach((key) => localStorage.removeItem(key));

//       localStorage.setItem('stagestorage', stageName);
//       localStorage.setItem('crmDataMode', 'true');

//       // 🔥 إضافة CRM Data parameters
//       const queryParams = new URLSearchParams({
//         stage: encodeURIComponent(stageName),
//         ...crmParams,
//       });

//       navigate(`/TeamLeaderCRMDATAALLLeads?${queryParams.toString()}`);
//     }
//   };

//   // 🔥 تعريف اللون الموحد
//   const UNIFIED_COLOR = '#9C27B0'; // لون أرجواني للـ CRM Data

//   // ✅ إعداد بيانات الرسم البياني
//   const getStageChartData = useMemo(() => {
//     const labels = allStages.map((stage) => stage.stageName);
//     const data = allStages.map((stage) => stage.leadsCount);

//     const backgroundColors = labels.map((label) => {
//       if (label === 'Team Leader Pending') return '#9C27B0'; // أرجواني فاتح
//       if (label === 'Team Leader Fresh') return '#9C27B0'; // أرجواني فاتح
//       if (label === 'Done Deal' || label === 'Not Interested' || label === 'Cancel Meeting')
//         return '#E91E63'; // وردي
//       return UNIFIED_COLOR;
//     });

//     return {
//       labels: labels,
//       datasets: [
//         {
//           data,
//           backgroundColor: backgroundColors,
//           borderColor: mode === 'dark' ? '#1a1a2e' : '#ffffff',
//           borderWidth: 2,
//           hoverOffset: 15,
//           hoverBorderWidth: 3,
//         },
//       ],
//     };
//   }, [allStages, mode]);

//   const chartOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: {
//       legend: {
//         position: 'right',
//         labels: {
//           color: mode === 'dark' ? '#fff' : '#333',
//           font: {
//             size: 11,
//             family: 'Heebo, sans-serif',
//           },
//           padding: 20,
//           usePointStyle: true,
//           pointStyle: 'circle',
//         },
//       },
//       tooltip: {
//         backgroundColor: mode === 'dark' ? 'rgba(0,0,0,0.8)' : 'rgba(255,255,255,0.9)',
//         titleColor: mode === 'dark' ? '#fff' : '#333',
//         bodyColor: mode === 'dark' ? '#fff' : '#333',
//         borderColor: UNIFIED_COLOR,
//         borderWidth: 1,
//         callbacks: {
//           label: function (context) {
//             const label = context.label || '';
//             const value = context.raw || 0;
//             const total = context.dataset.data.reduce((a, b) => a + b, 0);
//             const percentage = total > 0 ? Math.round((value / total) * 100) : 0;
//             return `${label}: ${value} leads (${percentage}%)`;
//           },
//         },
//       },
//     },
//     cutout: '60%',
//   };

//   // ✅ زر الرجوع إلى Dashboard الرئيسي
//   const BackButton = () => (
//     <Button
//       variant="outlined"
//       startIcon={<ArrowBackIcon />}
//       onClick={() => navigate('/TeamLeaderDashboard')}
//       sx={{
//         color: UNIFIED_COLOR,
//         borderColor: UNIFIED_COLOR,
//         '&:hover': {
//           backgroundColor: UNIFIED_COLOR,
//           color: '#fff',
//           borderColor: UNIFIED_COLOR,
//         },
//         mb: 2,
//       }}
//     >
//       Back to Dashboard
//     </Button>
//   );

//   // ✅ عرض حالة التحميل الرئيسية (مثل الصفحة الثانية)
//   if (loading && !dashboardData) {
//     return (
//       <div
//         style={{
//           display: 'flex',
//           justifyContent: 'center',
//           alignItems: 'center',
//           minHeight: '100vh',
//           background: mode === 'dark' ? '#1a1a2e' : '#f8f9fa',
//         }}
//       >
//         <div className="text-center">
//           <CircularProgress
//             size={60}
//             sx={{
//               color: UNIFIED_COLOR,
//               mb: 2,
//               animationDuration: '0.8s',
//             }}
//           />
//           <h4
//             style={{
//               color: mode === 'dark' ? '#fff' : '#333',
//               fontFamily: '"Heebo", sans-serif',
//               fontWeight: '500',
//               marginTop: '20px',
//             }}
//           >
//             Loading CRM Dashboard...
//           </h4>
//           <p
//             style={{
//               color: mode === 'dark' ? '#aaa' : '#666',
//               fontSize: '0.9rem',
//               marginTop: '10px',
//             }}
//           >
//             Please wait while we load your CRM data
//           </p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div
//       style={{
//         background:
//           mode === 'dark'
//             ? 'linear-gradient(135deg, #0f0f23 0%, #1a1a2e 100%)'
//             : 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
//         minHeight: '100vh',
//         fontFamily: '"Heebo", "Segoe UI", sans-serif',
//         opacity: dataLoading ? 0.7 : 1,
//         transition: 'opacity 0.3s ease',
//       }}
//     >
//       {/* طبقة تحميل البيانات */}
//       {dataLoading && (
//         <div
//           style={{
//             position: 'fixed',
//             top: 0,
//             left: 0,
//             width: '100%',
//             height: '100%',
//             background: mode === 'dark' ? 'rgba(0,0,0,0.85)' : 'rgba(255,255,255,0.9)',
//             display: 'flex',
//             justifyContent: 'center',
//             alignItems: 'center',
//             zIndex: 9999,
//             backdropFilter: 'blur(3px)',
//           }}
//         >
//           <div className="text-center">
//             <CircularProgress
//               size={50}
//               sx={{
//                 color: UNIFIED_COLOR,
//                 mb: 2,
//               }}
//             />
//             <h5
//               style={{
//                 color: mode === 'dark' ? '#fff' : '#333',
//                 fontFamily: '"Heebo", sans-serif',
//                 fontWeight: '500',
//               }}
//             >
//               Loading CRM Data...
//             </h5>
//             <p
//               style={{
//                 color: mode === 'dark' ? '#aaa' : '#666',
//                 fontSize: '0.85rem',
//                 marginTop: '5px',
//               }}
//             >
//               Fetching the latest CRM statistics
//             </p>
//           </div>
//         </div>
//       )}

//       <Container className="py-4" style={{ marginTop: '80px' }}>
//         {/* زر الرجوع */}
//         <div className="mb-4">
//           <BackButton />
//         </div>

//         {/* ✅ قسم الترحيب للـ CRM Data */}
//         <div className="welcome-section mb-5 text-center">
//           <div className="position-relative">
//             <DashboardIcon
//               sx={{
//                 fontSize: 80,
//                 color: mode === 'dark' ? 'rgba(156, 39, 176, 0.3)' : 'rgba(156, 39, 176, 0.1)',
//                 position: 'absolute',
//                 top: '-20px',
//                 left: '50%',
//                 transform: 'translateX(-50%)',
//                 zIndex: 0,
//               }}
//             />
//             <h2
//               className="fw-bold heebo-bold position-relative"
//               style={{
//                 color: UNIFIED_COLOR,
//                 fontSize: '2.2rem',
//                 textShadow:
//                   mode === 'dark' ? '0 2px 4px rgba(0,0,0,0.3)' : '0 2px 4px rgba(0,0,0,0.1)',
//                 zIndex: 1,
//               }}
//             >
//               CRM Data Dashboard / {teamleaderInfo.name || userlogin?.data?.name}
//             </h2>
//             <p
//               className="mt-2"
//               style={{
//                 fontSize: '1.1rem',
//                 color: mode === 'dark' ? '#aaa' : '#666',
//                 maxWidth: '600px',
//                 margin: '0 auto',
//               }}
//             >
//               {dashboardData?.data?.meta && (
//                 <small className="d-block mt-1" style={{ fontSize: '0.9rem' }}>
//                   CRM Data loaded in {dashboardData.data.meta.executionTime} •
//                   {dashboardData.data.meta.fromCache ? ' Cached' : ' Fresh'}
//                 </small>
//               )}
//             </p>
//           </div>
//         </div>

//         {/* 📊 قسم الإحصائيات السريعة */}
//         <Row className="mb-5">
//           <Col xs={12} className="mb-4">
//             <div className="d-flex align-items-center justify-content-between">
//               <div className="d-flex align-items-center">
//                 <ShowChartIcon sx={{ color: UNIFIED_COLOR, mr: 1 }} />
//                 <h4 className="mb-0 fw-bold" style={{ color: mode === 'dark' ? '#fff' : '#333' }}>
//                   CRM Quick Numbers
//                 </h4>
//               </div>
//             </div>
//           </Col>

//           {/* زر All Leads في قسم Quick Numbers */}
//           <Col xs={12} md={4} className="mb-4">
//             <div
//               className="dashboard-card shadow-lg"
//               style={{
//                 background:
//                   mode === 'dark'
//                     ? 'linear-gradient(135deg, #1e1e2e 0%, #2d2d44 100%)'
//                     : 'linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%)',
//                 border: 'none',
//                 borderRadius: '20px',
//                 overflow: 'hidden',
//                 cursor: 'pointer',
//                 transition: 'all 0.3s ease',
//                 height: '100%',
//                 borderLeft: `5px solid ${UNIFIED_COLOR}`,
//               }}
//               onClick={() => handleStageClick({ stageName: 'All Leads' })}
//               onMouseEnter={(e) => {
//                 e.currentTarget.style.transform = 'translateY(-5px)';
//                 e.currentTarget.style.boxShadow = `0 10px 25px ${UNIFIED_COLOR}33`;
//               }}
//               onMouseLeave={(e) => {
//                 e.currentTarget.style.transform = 'translateY(0)';
//                 e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.1)';
//               }}
//             >
//               <div className="text-center p-4">
//                 <div className="mb-3">
//                   <div
//                     style={{
//                       width: '70px',
//                       height: '70px',
//                       background: `linear-gradient(135deg, ${UNIFIED_COLOR} 0%, #BA68C8 100%)`,
//                       borderRadius: '50%',
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       margin: '0 auto',
//                     }}
//                   >
//                     <PeopleIcon sx={{ color: '#fff', fontSize: 35 }} />
//                   </div>
//                 </div>
//                 <h5 className="fw-bold mb-2" style={{ color: mode === 'dark' ? '#ccc' : '#666' }}>
//                   All CRM Leads
//                 </h5>
//                 <h1 className="fw-bold display-6" style={{ color: UNIFIED_COLOR }}>
//                   {totalLeads}
//                 </h1>
//                 <small style={{ color: mode === 'dark' ? '#aaa' : '#888' }}>
//                   View all CRM Data leads
//                 </small>
//               </div>
//             </div>
//           </Col>

//           {/* كارت Team Leader Pending */}
//           <Col xs={12} md={4} className="mb-4">
//             <div
//               className="dashboard-card shadow-lg"
//               style={{
//                 background:
//                   mode === 'dark'
//                     ? 'linear-gradient(135deg, #1e1e2e 0%, #2d2d44 100%)'
//                     : 'linear-gradient(135deg, #ffffff 0%, #fff8f0 100%)',
//                 border: 'none',
//                 borderRadius: '20px',
//                 overflow: 'hidden',
//                 cursor: 'pointer',
//                 transition: 'all 0.3s ease',
//                 height: '100%',
//                 borderLeft: `5px solid ${UNIFIED_COLOR}`,
//               }}
//               onClick={() =>
//                 handleStageClick({
//                   stageName: 'Team Leader Pending',
//                   isTeamLeaderPending: true,
//                   leadsCount: teamLeaderPending.leadsCount,
//                   salesIds: teamLeaderPending.salesIds,
//                 })
//               }
//               onMouseEnter={(e) => {
//                 e.currentTarget.style.transform = 'translateY(-5px)';
//                 e.currentTarget.style.boxShadow = `0 10px 25px ${UNIFIED_COLOR}33`;
//               }}
//               onMouseLeave={(e) => {
//                 e.currentTarget.style.transform = 'translateY(0)';
//                 e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.1)';
//               }}
//             >
//               <div className="text-center p-4">
//                 <div className="mb-3">
//                   <div
//                     style={{
//                       width: '70px',
//                       height: '70px',
//                       background: `linear-gradient(135deg, ${UNIFIED_COLOR} 0%, #BA68C8 100%)`,
//                       borderRadius: '50%',
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       margin: '0 auto',
//                     }}
//                   >
//                     <PendingActionsIcon sx={{ color: '#fff', fontSize: 35 }} />
//                   </div>
//                 </div>
//                 <h5 className="fw-bold mb-2" style={{ color: mode === 'dark' ? '#ccc' : '#666' }}>
//                   CRM Pending
//                 </h5>
//                 <h1 className="fw-bold display-6" style={{ color: UNIFIED_COLOR }}>
//                   {teamLeaderPending.leadsCount || 0}
//                 </h1>
//                 <div className="mt-2">
//                   {totalLeads > 0 && (
//                     <div>
//                       <small style={{ color: mode === 'dark' ? '#aaa' : '#888' }}>
//                         CRM Pending:{' '}
//                         {((teamLeaderPending.leadsCount / totalLeads) * 100).toFixed(1)}%
//                       </small>
//                       <ProgressBar
//                         now={(teamLeaderPending.leadsCount / totalLeads) * 100}
//                         style={{
//                           height: '8px',
//                           borderRadius: '4px',
//                           marginTop: '5px',
//                           backgroundColor:
//                             mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
//                         }}
//                       />
//                     </div>
//                   )}
//                 </div>
//                 <small
//                   style={{
//                     color: mode === 'dark' ? '#aaa' : '#888',
//                     fontSize: '0.8rem',
//                     marginTop: '10px',
//                     display: 'block',
//                   }}
//                 >
//                   CRM Pending leads assigned to you
//                 </small>
//               </div>
//             </div>
//           </Col>

//           {/* كارت Team Leader Fresh */}
//           <Col xs={12} md={4} className="mb-4">
//             <div
//               className="dashboard-card shadow-lg"
//               style={{
//                 background:
//                   mode === 'dark'
//                     ? 'linear-gradient(135deg, #1e1e2e 0%, #2d2d44 100%)'
//                     : 'linear-gradient(135deg, #ffffff 0%, #f0fff7 100%)',
//                 border: 'none',
//                 borderRadius: '20px',
//                 overflow: 'hidden',
//                 cursor: 'pointer',
//                 transition: 'all 0.3s ease',
//                 height: '100%',
//                 borderLeft: `5px solid ${UNIFIED_COLOR}`,
//               }}
//               onClick={() =>
//                 handleStageClick({
//                   stageName: 'Team Leader Fresh',
//                   isTeamLeaderFresh: true,
//                   leadsCount: teamLeaderFresh.leadsCount,
//                 })
//               }
//               onMouseEnter={(e) => {
//                 e.currentTarget.style.transform = 'translateY(-5px)';
//                 e.currentTarget.style.boxShadow = `0 10px 25px ${UNIFIED_COLOR}33`;
//               }}
//               onMouseLeave={(e) => {
//                 e.currentTarget.style.transform = 'translateY(0)';
//                 e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.1)';
//               }}
//             >
//               <div className="text-center p-4">
//                 <div className="mb-3">
//                   <div
//                     style={{
//                       width: '70px',
//                       height: '70px',
//                       background: `linear-gradient(135deg, ${UNIFIED_COLOR} 0%, #BA68C8 100%)`,
//                       borderRadius: '50%',
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       margin: '0 auto',
//                     }}
//                   >
//                     <TipsAndUpdatesIcon sx={{ color: '#fff', fontSize: 35 }} />
//                   </div>
//                 </div>
//                 <h5 className="fw-bold mb-2" style={{ color: mode === 'dark' ? '#ccc' : '#666' }}>
//                   CRM Fresh
//                 </h5>
//                 <h1 className="fw-bold display-6" style={{ color: UNIFIED_COLOR }}>
//                   {teamLeaderFresh.leadsCount || 0}
//                 </h1>
//                 <div className="mt-2">
//                   {totalLeads > 0 && (
//                     <div>
//                       <small style={{ color: mode === 'dark' ? '#aaa' : '#888' }}>
//                         CRM Fresh: {((teamLeaderFresh.leadsCount / totalLeads) * 100).toFixed(1)}%
//                       </small>
//                       <ProgressBar
//                         now={(teamLeaderFresh.leadsCount / totalLeads) * 100}
//                         style={{
//                           height: '8px',
//                           borderRadius: '4px',
//                           marginTop: '5px',
//                           backgroundColor:
//                             mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
//                         }}
//                       />
//                     </div>
//                   )}
//                 </div>
//                 <small
//                   style={{
//                     color: mode === 'dark' ? '#aaa' : '#888',
//                     fontSize: '0.8rem',
//                     marginTop: '10px',
//                     display: 'block',
//                   }}
//                 >
//                   CRM [Fresh] leads assigned to you
//                 </small>
//               </div>
//             </div>
//           </Col>
//         </Row>

//         {/* 🎯 كروت المراحل المرتبة */}
//         <Row className="mb-5">
//           <Col xs={12}>
//             <div className="mb-4">
//               <div className="d-flex align-items-center mb-2">
//                 <BookmarkIcon
//                   sx={{
//                     mr: 2,
//                     color: UNIFIED_COLOR,
//                     fontSize: '2.8rem',
//                     background: mode === 'dark' ? `${UNIFIED_COLOR}20` : `${UNIFIED_COLOR}10`,
//                     padding: '10px',
//                     borderRadius: '12px',
//                   }}
//                 />
//                 <div>
//                   <h4
//                     className="fw-bold mb-1"
//                     style={{
//                       color: mode === 'dark' ? '#fff' : '#333',
//                       fontSize: '1.4rem',
//                     }}
//                   >
//                     CRM Data Stages ({allStages.length})
//                   </h4>
//                   <small
//                     style={{
//                       color: mode === 'dark' ? '#aaa' : '#666',
//                       fontSize: '0.9rem',
//                     }}
//                   >
//                     Click any stage to view CRM Data leads
//                   </small>
//                 </div>
//               </div>
//             </div>
//           </Col>

//           {/* كروت جميع المراحل */}
//           {allStages.map((stage) => {
//             const percentage =
//               totalLeads > 0 ? ((stage.leadsCount / totalLeads) * 100).toFixed(1) : 0;

//             // تحديد اللون بناءً على المرحلة
//             let stageColor = UNIFIED_COLOR;
//             if (stage.stageName === 'Team Leader Pending') stageColor = UNIFIED_COLOR;
//             if (stage.stageName === 'Team Leader Fresh') stageColor = UNIFIED_COLOR;
//             if (
//               stage.stageName === 'Done Deal' ||
//               stage.stageName === 'Not Interested' ||
//               stage.stageName === 'Cancel Meeting'
//             ) {
//               stageColor = '#E91E63';
//             }

//             return (
//               <Col
//                 key={stage.stageId || stage.stageName}
//                 xs={12}
//                 sm={6}
//                 md={4}
//                 lg={3}
//                 className="mb-4"
//               >
//                 <div
//                   className="stage-card"
//                   onClick={() => handleStageClick(stage)}
//                   style={{
//                     background: mode === 'dark' ? '#1e1e2e' : '#ffffff',
//                     border:
//                       mode === 'dark' ? `1px solid ${stageColor}20` : `1px solid ${stageColor}10`,
//                     borderRadius: '16px',
//                     cursor: 'pointer',
//                     transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
//                     height: '100%',
//                     overflow: 'hidden',
//                     position: 'relative',
//                     boxShadow:
//                       mode === 'dark'
//                         ? '0 4px 12px rgba(0, 0, 0, 0.2)'
//                         : '0 4px 12px rgba(0, 0, 0, 0.05)',
//                   }}
//                   onMouseEnter={(e) => {
//                     e.currentTarget.style.transform = 'translateY(-4px) scale(1.02)';
//                     e.currentTarget.style.boxShadow =
//                       mode === 'dark'
//                         ? `0 12px 24px rgba(0, 0, 0, 0.3), 0 0 0 1px ${stageColor}40`
//                         : `0 12px 24px rgba(0, 0, 0, 0.08), 0 0 0 1px ${stageColor}20`;
//                     e.currentTarget.style.borderColor = `${stageColor}40`;
//                     e.currentTarget.style.background =
//                       mode === 'dark' ? '#222233' : `${stageColor}08`;
//                   }}
//                   onMouseLeave={(e) => {
//                     e.currentTarget.style.transform = 'translateY(0) scale(1)';
//                     e.currentTarget.style.boxShadow =
//                       mode === 'dark'
//                         ? '0 4px 12px rgba(0, 0, 0, 0.2)'
//                         : '0 4px 12px rgba(0, 0, 0, 0.05)';
//                     e.currentTarget.style.borderColor =
//                       mode === 'dark' ? `${stageColor}20` : `${stageColor}10`;
//                     e.currentTarget.style.background = mode === 'dark' ? '#1e1e2e' : '#ffffff';
//                   }}
//                 >
//                   <div
//                     style={{
//                       height: '4px',
//                       background: `linear-gradient(135deg, ${stageColor} 0%, ${stageColor}80 100%)`,
//                       width: '100%',
//                     }}
//                   />

//                   <div className="p-4">
//                     <div className="d-flex align-items-center justify-content-between mb-3">
//                       <div
//                         style={{
//                           width: '44px',
//                           height: '44px',
//                           background: mode === 'dark' ? `${stageColor}20` : `${stageColor}10`,
//                           borderRadius: '12px',
//                           display: 'flex',
//                           alignItems: 'center',
//                           justifyContent: 'center',
//                           border: `1px solid ${stageColor}30`,
//                         }}
//                       >
//                         {React.cloneElement(
//                           stagesIcons[stage.stageName] || <AccessibilityNewIcon />,
//                           {
//                             sx: {
//                               color: stageColor,
//                               fontSize: 22,
//                             },
//                           },
//                         )}
//                       </div>

//                       <div
//                         style={{
//                           background: mode === 'dark' ? `${stageColor}20` : `${stageColor}10`,
//                           padding: '4px 12px',
//                           borderRadius: '20px',
//                           border: `1px solid ${stageColor}30`,
//                         }}
//                       >
//                         <span
//                           style={{
//                             color: stageColor,
//                             fontSize: '0.8rem',
//                             fontWeight: '600',
//                           }}
//                         >
//                           {percentage}%
//                         </span>
//                       </div>
//                     </div>

//                     <h6
//                       className="fw-bold mb-2"
//                       style={{
//                         color: mode === 'dark' ? '#fff' : '#333',
//                         fontSize: '1rem',
//                         lineHeight: '1.4',
//                       }}
//                     >
//                       {stage.stageName}
//                     </h6>

//                     <div className="mb-3">
//                       <div
//                         style={{
//                           fontSize: '2rem',
//                           fontWeight: '700',
//                           color: stageColor,
//                           lineHeight: '1',
//                           marginBottom: '4px',
//                         }}
//                       >
//                         {stage.leadsCount}
//                       </div>
//                       <small
//                         style={{
//                           color: mode === 'dark' ? '#aaa' : '#666',
//                           fontSize: '0.8rem',
//                         }}
//                       >
//                         CRM leads
//                         {stage.isTeamLeaderFresh && ' (assigned to you)'}
//                         {stage.isTeamLeaderPending && ' (your pending)'}
//                       </small>
//                     </div>

//                     <div>
//                       <div className="d-flex justify-content-between mb-1">
//                         <small
//                           style={{
//                             color: mode === 'dark' ? '#888' : '#777',
//                             fontSize: '0.75rem',
//                             fontWeight: '500',
//                           }}
//                         >
//                           Progress
//                         </small>
//                         <small
//                           style={{
//                             color: stageColor,
//                             fontSize: '0.75rem',
//                             fontWeight: '600',
//                           }}
//                         >
//                           {stage.leadsCount} of {totalLeads}
//                         </small>
//                       </div>
//                       <div
//                         style={{
//                           height: '6px',
//                           background:
//                             mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.08)',
//                           borderRadius: '3px',
//                           overflow: 'hidden',
//                           position: 'relative',
//                         }}
//                       >
//                         <div
//                           style={{
//                             width: `${percentage}%`,
//                             height: '100%',
//                             background: `linear-gradient(135deg, ${stageColor} 0%, ${stageColor}80 100%)`,
//                             borderRadius: '3px',
//                             transition: 'width 0.5s ease',
//                           }}
//                         />
//                       </div>
//                     </div>
//                   </div>

//                   <div className="px-4 pb-3">
//                     <div
//                       style={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         padding: '8px',
//                         background: mode === 'dark' ? `${stageColor}20` : `${stageColor}10`,
//                         borderRadius: '8px',
//                         border: `1px solid ${stageColor}30`,
//                         cursor: 'pointer',
//                         transition: 'all 0.2s ease',
//                       }}
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         handleStageClick(stage);
//                       }}
//                       onMouseEnter={(e) => {
//                         e.currentTarget.style.background = stageColor;
//                         e.currentTarget.style.borderColor = stageColor;
//                         const span = e.currentTarget.querySelector('span');
//                         const svg = e.currentTarget.querySelector('svg');
//                         if (span) span.style.color = '#fff';
//                         if (svg) svg.style.color = '#fff';
//                       }}
//                       onMouseLeave={(e) => {
//                         e.currentTarget.style.background =
//                           mode === 'dark' ? `${stageColor}20` : `${stageColor}10`;
//                         e.currentTarget.style.borderColor = `${stageColor}30`;
//                         const span = e.currentTarget.querySelector('span');
//                         const svg = e.currentTarget.querySelector('svg');
//                         if (span) span.style.color = stageColor;
//                         if (svg) svg.style.color = stageColor;
//                       }}
//                     >
//                       <span
//                         style={{
//                           color: stageColor,
//                           fontSize: '0.8rem',
//                           fontWeight: '600',
//                           marginRight: '6px',
//                           transition: 'color 0.2s ease',
//                         }}
//                       >
//                         View CRM Leads
//                       </span>
//                       <ArrowForwardIcon
//                         sx={{
//                           color: stageColor,
//                           fontSize: 16,
//                           transition: 'color 0.2s ease',
//                         }}
//                       />
//                     </div>
//                   </div>
//                 </div>
//               </Col>
//             );
//           })}
//         </Row>

//         {/* 📊 الرسم البياني للـ Stages */}
//         <Row className="mb-5">
//           <Col xs={12} lg={6} className="mb-4">
//             <div
//               className="shadow-lg"
//               style={{
//                 background:
//                   mode === 'dark'
//                     ? 'linear-gradient(135deg, #1e1e2e 0%, #2d2d44 100%)'
//                     : 'linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%)',
//                 border: 'none',
//                 borderRadius: '20px',
//                 overflow: 'hidden',
//                 height: '100%',
//               }}
//             >
//               <div className="p-4">
//                 <div className="mb-4">
//                   <h5 className="fw-bold mb-1" style={{ color: mode === 'dark' ? '#fff' : '#333' }}>
//                     <BarChartIcon sx={{ mr: 1, color: UNIFIED_COLOR }} />
//                     CRM Data Distribution by Stage
//                   </h5>
//                   <small style={{ color: mode === 'dark' ? '#aaa' : '#666' }}>
//                     Visual breakdown of CRM Data leads across all stages
//                   </small>
//                 </div>
//                 <div style={{ height: '350px', position: 'relative' }}>
//                   <Doughnut data={getStageChartData} options={chartOptions} />
//                 </div>
//               </div>
//             </div>
//           </Col>

//           {/* 🎯 قائمة المراحل المرتبة */}
//           <Col xs={12} lg={6} className="mb-4">
//             <div
//               className="shadow-lg"
//               style={{
//                 background:
//                   mode === 'dark'
//                     ? 'linear-gradient(135deg, #1e1e2e 0%, #2d2d44 100%)'
//                     : 'linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%)',
//                 border: 'none',
//                 borderRadius: '20px',
//                 overflow: 'hidden',
//                 height: '100%',
//               }}
//             >
//               <div className="p-4">
//                 <div className="mb-4">
//                   <h5 className="fw-bold mb-1" style={{ color: mode === 'dark' ? '#fff' : '#333' }}>
//                     <BookmarkIcon sx={{ mr: 1, color: UNIFIED_COLOR }} />
//                     CRM Stages Overview
//                   </h5>
//                   <small style={{ color: mode === 'dark' ? '#aaa' : '#666' }}>
//                     Click any stage to view CRM Data leads
//                   </small>
//                 </div>

//                 <div
//                   style={{
//                     maxHeight: '350px',
//                     overflowY: 'auto',
//                     paddingRight: '10px',
//                   }}
//                 >
//                   {allStages.map((stage) => {
//                     const percentage =
//                       totalLeads > 0 ? ((stage.leadsCount / totalLeads) * 100).toFixed(1) : 0;

//                     let stageColor = UNIFIED_COLOR;
//                     if (stage.stageName === 'Team Leader Pending') stageColor = UNIFIED_COLOR;
//                     if (stage.stageName === 'Team Leader Fresh') stageColor = UNIFIED_COLOR;
//                     if (
//                       stage.stageName === 'Done Deal' ||
//                       stage.stageName === 'Not Interested' ||
//                       stage.stageName === 'Cancel Meeting'
//                     ) {
//                       stageColor = '#E91E63';
//                     }

//                     return (
//                       <div
//                         key={stage.stageId || stage.stageName}
//                         className="mb-3 stage-list-card"
//                         onClick={() => handleStageClick(stage)}
//                         style={{
//                           background: mode === 'dark' ? '#2d2d44' : '#ffffff',
//                           border: '1px solid',
//                           borderColor: mode === 'dark' ? '#3d3d5c' : '#e0e0e0',
//                           borderRadius: '12px',
//                           cursor: 'pointer',
//                           transition: 'all 0.3s ease',
//                         }}
//                         onMouseEnter={(e) => {
//                           e.currentTarget.style.transform = 'translateX(5px)';
//                           e.currentTarget.style.borderColor = stageColor;
//                         }}
//                         onMouseLeave={(e) => {
//                           e.currentTarget.style.transform = 'translateX(0)';
//                           e.currentTarget.style.borderColor =
//                             mode === 'dark' ? '#3d3d5c' : '#e0e0e0';
//                         }}
//                       >
//                         <div className="p-3">
//                           <div className="d-flex align-items-center justify-content-between">
//                             <div className="d-flex align-items-center" style={{ flex: 1 }}>
//                               <div className="me-3">
//                                 {React.cloneElement(
//                                   stagesIcons[stage.stageName] || <AccessibilityNewIcon />,
//                                   {
//                                     sx: { color: stageColor },
//                                   },
//                                 )}
//                               </div>
//                               <div style={{ flex: 1 }}>
//                                 <h6
//                                   className="fw-bold mb-1"
//                                   style={{
//                                     color: mode === 'dark' ? '#fff' : '#333',
//                                     fontSize: '0.9rem',
//                                   }}
//                                 >
//                                   {stage.stageName}
//                                 </h6>
//                                 <div className="d-flex align-items-center">
//                                   <div style={{ flex: 1, marginRight: '10px' }}>
//                                     <div
//                                       style={{
//                                         height: '6px',
//                                         background:
//                                           mode === 'dark'
//                                             ? 'rgba(255,255,255,0.1)'
//                                             : 'rgba(0,0,0,0.1)',
//                                         borderRadius: '3px',
//                                         overflow: 'hidden',
//                                       }}
//                                     >
//                                       <div
//                                         style={{
//                                           width: `${percentage}%`,
//                                           height: '100%',
//                                           background: `linear-gradient(90deg, ${stageColor} 0%, ${stageColor}80 100%)`,
//                                           borderRadius: '3px',
//                                         }}
//                                       />
//                                     </div>
//                                   </div>
//                                   <span
//                                     style={{
//                                       fontSize: '0.8rem',
//                                       color: mode === 'dark' ? '#aaa' : '#666',
//                                       minWidth: '60px',
//                                       textAlign: 'right',
//                                     }}
//                                   >
//                                     {percentage}%
//                                   </span>
//                                 </div>
//                               </div>
//                             </div>

//                             <div className="text-end" style={{ minWidth: '80px' }}>
//                               <div
//                                 style={{
//                                   fontSize: '1.2rem',
//                                   fontWeight: 'bold',
//                                   color: stageColor,
//                                 }}
//                               >
//                                 {stage.leadsCount}
//                               </div>
//                               <small
//                                 style={{
//                                   fontSize: '0.75rem',
//                                   color: mode === 'dark' ? '#aaa' : '#888',
//                                 }}
//                               >
//                                 CRM leads
//                               </small>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     );
//                   })}
//                 </div>
//               </div>
//             </div>
//           </Col>
//         </Row>
//       </Container>

//       {/* تخصيص Styles */}
//       <style>
//         {`
//           .progress-bar {
//             background-color: ${UNIFIED_COLOR} !important;
//           }
          
//           .stage-card:hover {
//             transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
//           }
          
//           .heebo-bold {
//             font-family: 'Heebo', sans-serif;
//             font-weight: 700 !important;
//           }
          
//           .dashboard-card {
//             border-radius: 20px !important;
//             box-shadow: 0 4px 15px rgba(0,0,0,0.1);
//           }
          
//           ::-webkit-scrollbar {
//             width: 6px;
//           }
          
//           ::-webkit-scrollbar-track {
//             background: ${mode === 'dark' ? '#1a1a2e' : '#f1f1f1'};
//             border-radius: 10px;
//           }
          
//           ::-webkit-scrollbar-thumb {
//             background: ${UNIFIED_COLOR};
//             border-radius: 10px;
//           }
          
//           ::-webkit-scrollbar-thumb:hover {
//             background: #BA68C8;
//           }
          
//           @keyframes fadeInUp {
//             from {
//               opacity: 0;
//               transform: translateY(20px);
//             }
//             to {
//               opacity: 1;
//               transform: translateY(0);
//             }
//           }
          
//           .stage-list-card {
//             animation: fadeInUp 0.3s ease-out;
//           }
          
//           @keyframes loadingPulse {
//             0% { opacity: 1; }
//             50% { opacity: 0.5; }
//             100% { opacity: 1; }
//           }
          
//           .loading-text {
//             animation: loadingPulse 1.5s infinite;
//           }
          
//           .crm-badge {
//             background: linear-gradient(135deg, ${UNIFIED_COLOR} 0%, #BA68C8 100%);
//             color: white;
//             padding: 2px 8px;
//             border-radius: 10px;
//             font-size: 0.75rem;
//             font-weight: 600;
//             display: inline-block;
//             margin-left: 8px;
//           }
          
//           @keyframes fadeIn {
//             from { opacity: 0; }
//             to { opacity: 1; }
//           }
//         `}
//       </style>
//     </div>
//   );
// };













// 20-5-2026
import React, { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { useTheme, useMediaQuery } from '@mui/material';
import {
  AccessibilityNew as AccessibilityNewIcon,
  TipsAndUpdates as TipsAndUpdatesIcon,
  Bookmark as BookmarkIcon,
  AccessTimeFilled as AccessTimeFilledIcon,
  AccessAlarm as AccessAlarmIcon,
  TaskAlt as TaskAltIcon,
  PhonelinkErase as PhonelinkEraseIcon,
  ThumbUp as ThumbUpIcon,
  Cancel as CancelIcon,
  WorkHistory as WorkHistoryIcon,
  Backspace as BackspaceIcon,
  ShowChart as ShowChartIcon,
  BarChart as BarChartIcon,
  PendingActions as PendingActionsIcon,
  People as PeopleIcon,
  ArrowBack as ArrowBackIcon,
  Dashboard as DashboardIcon,
} from '@mui/icons-material';
import { Doughnut } from 'react-chartjs-2';
import {
  Chart as ChartJS, ArcElement, Tooltip, Legend,
  CategoryScale, LinearScale, PointElement, LineElement, Title, Filler,
} from 'chart.js';

import { GetteamleaderdashboarddatabyteamleaderemailadvancedCRMDATA } from '../../Redux/Actions/RoleData_Actions';
import { useSidebarWidth } from '../../Utility/useSidebarWidth';

ChartJS.register(ArcElement, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler);

/* ─── Design tokens — IDENTICAL to TeamLeaderDashboard ──────────────────── */
const C = {
  bg:         '#F7F8FC',
  white:      '#FFFFFF',
  border:     '#E8EAF0',
  accent:     '#0D47A1',
  accentDark: '#0a3880',
  accentSoft: 'rgba(13,71,161,0.07)',
  text:       '#1C2340',
  textMuted:  '#7B829A',
  warning:    '#F79009',
  shadow:     '0 1px 3px rgba(16,24,40,0.08)',
  shadowMd:   '0 4px 16px rgba(16,24,40,0.10)',
};

const SIDEBAR_COLLAPSED = 64;

/* ─── Stage icons ─────────────────────────────────────────────────────────── */
const STAGE_ICONS = {
  Fresh:                    <TipsAndUpdatesIcon />,
  'No Stage':               <TipsAndUpdatesIcon />,
  'Team Leader Fresh':      <TipsAndUpdatesIcon />,
  'Team Leader Pending':    <PendingActionsIcon />,
  Pending:                  <PendingActionsIcon />,
  Follow:                   <BookmarkIcon />,
  'Follow Up':              <BookmarkIcon />,
  'Long Follow':            <BookmarkIcon />,
  Transfer:                 <BackspaceIcon />,
  Interested:               <ThumbUpIcon />,
  'Not Interested':         <BackspaceIcon />,
  Meeting:                  <AccessTimeFilledIcon />,
  'Following After Meeting':<WorkHistoryIcon />,
  'Follow After Meeting':   <WorkHistoryIcon />,
  'Cancel Meeting':         <CancelIcon />,
  'Done Deal':              <TaskAltIcon />,
  'No Answer':              <PhonelinkEraseIcon />,
  'No Answer 1st Call':     <AccessAlarmIcon />,
  Cancellation:             <CancelIcon />,
};

/* ─── stage colour — Pending = amber, rest = purple ─────────────────────── */
const getStageColor = (name) => {
  if (name === 'Team Leader Pending' || name === 'Pending') return C.warning;
  return C.accent;
};

/* ─── Stat card — identical shape to TeamLeaderDashboard ────────────────── */
const StatCard = ({ label, value, highlight, color, onClick }) => {
  const bg   = highlight ? (color || C.accent) : C.white;
  const bdr  = highlight ? (color || C.accent) : C.border;
  const shad = highlight ? `0 4px 16px ${color || C.accent}40` : C.shadow;
  return (
    <div
      onClick={onClick}
      style={{
        background: bg, border: `1px solid ${bdr}`, borderRadius: 12,
        padding: '20px 24px', minWidth: 160, height: 120,
        boxShadow: shad,
        display: 'flex', flexDirection: 'column', justifyContent: 'space-between',
        cursor: onClick ? 'pointer' : 'default', flexShrink: 0,
        transition: 'transform 0.15s, box-shadow 0.15s',
      }}
      onMouseEnter={e => { if (onClick) { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = `0 8px 24px ${color || C.accent}30`; } }}
      onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = shad; }}
    >
      <span style={{ fontSize: 11, fontWeight: 500, color: highlight ? 'rgba(255,255,255,0.75)' : C.textMuted, letterSpacing: '0.06em', textTransform: 'uppercase', fontFamily: "'DM Sans', sans-serif" }}>{label}</span>
      <span style={{ fontSize: 26, fontWeight: 700, color: highlight ? '#fff' : C.text, fontFamily: "'DM Sans', sans-serif", lineHeight: 1.2 }}>{value ?? '—'}</span>
      {highlight && <div style={{ height: 3, width: 40, background: '#fff', borderRadius: 2, opacity: 0.4 }} />}
    </div>
  );
};

/* ─── Stage card — identical to TeamLeaderDashboard's StageCard ─────────── */
const StageCard = ({ stage, totalLeads, onStageClick }) => {
  const color  = getStageColor(stage.stageName);
  const count  = stage.leadsCount || 0;
  const pct    = totalLeads > 0 ? ((count / totalLeads) * 100).toFixed(1) : 0;
  const icon   = STAGE_ICONS[stage.stageName] || <AccessibilityNewIcon />;
  const isWarm = color === C.warning;

  return (
    <div
      onClick={() => onStageClick(stage)}
      style={{
        background: isWarm ? C.warning : C.white,
        border: `1px solid ${isWarm ? C.warning : C.border}`,
        borderRadius: 10, padding: '12px 16px', cursor: 'pointer',
        transition: 'transform 0.15s, box-shadow 0.15s, border-color 0.15s',
        boxShadow: isWarm ? `0 4px 16px rgba(247,144,9,0.30)` : C.shadow,
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        gap: 10, minHeight: 70,
      }}
      onMouseEnter={e => {
        e.currentTarget.style.transform = 'translateY(-2px)';
        e.currentTarget.style.boxShadow = `0 8px 24px ${color}40`;
        if (!isWarm) e.currentTarget.style.borderColor = color;
      }}
      onMouseLeave={e => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = isWarm ? `0 4px 16px rgba(247,144,9,0.30)` : C.shadow;
        e.currentTarget.style.borderColor = isWarm ? C.warning : C.border;
      }}
    >
      <div style={{ minWidth: 0 }}>
        <div style={{ fontSize: 10, fontWeight: 600, letterSpacing: '0.07em', textTransform: 'uppercase', color: isWarm ? 'rgba(255,255,255,0.85)' : C.textMuted, fontFamily: "'DM Sans', sans-serif", marginBottom: 4, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {stage.stageName}
        </div>
        <div style={{ display: 'flex', alignItems: 'baseline', gap: 5 }}>
          <span style={{ fontSize: 24, fontWeight: 800, lineHeight: 1, color: isWarm ? '#fff' : color, fontFamily: "'DM Sans', sans-serif" }}>{count}</span>
          <span style={{ fontSize: 11, fontWeight: 500, color: isWarm ? 'rgba(255,255,255,0.7)' : C.textMuted, fontFamily: "'DM Sans', sans-serif" }}>{pct}%</span>
        </div>
      </div>
      <div style={{ flexShrink: 0, opacity: isWarm ? 0.9 : 0.55, display: 'flex', alignItems: 'center' }}>
        {React.cloneElement(icon, { sx: { color: isWarm ? '#fff' : color, fontSize: 22 } })}
      </div>
    </div>
  );
};

/* ─── Stage list row — identical to TeamLeaderDashboard's StageRow ──────── */
const StageRow = ({ stage, totalLeads, onStageClick }) => {
  const color = getStageColor(stage.stageName);
  const count = stage.leadsCount || 0;
  const pct   = totalLeads > 0 ? ((count / totalLeads) * 100).toFixed(1) : 0;
  const icon  = STAGE_ICONS[stage.stageName] || <AccessibilityNewIcon />;

  return (
    <div
      onClick={() => onStageClick(stage)}
      style={{
        display: 'flex', alignItems: 'center', gap: 12,
        padding: '12px 16px', background: C.white,
        border: `1px solid ${C.border}`, borderRadius: 10,
        cursor: 'pointer', marginBottom: 8,
        transition: 'transform 0.15s, border-color 0.15s',
      }}
      onMouseEnter={e => { e.currentTarget.style.transform = 'translateX(4px)'; e.currentTarget.style.borderColor = color; }}
      onMouseLeave={e => { e.currentTarget.style.transform = 'translateX(0)'; e.currentTarget.style.borderColor = C.border; }}
    >
      <div style={{ width: 34, height: 34, borderRadius: 8, background: color + '12', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
        {React.cloneElement(icon, { sx: { color, fontSize: 18 } })}
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 13, fontWeight: 600, color: C.text, fontFamily: "'DM Sans', sans-serif", marginBottom: 5 }}>{stage.stageName}</div>
        <div style={{ height: 4, background: C.border, borderRadius: 2, overflow: 'hidden' }}>
          <div style={{ width: `${pct}%`, height: '100%', background: color, borderRadius: 2 }} />
        </div>
      </div>
      <div style={{ textAlign: 'right', flexShrink: 0 }}>
        <div style={{ fontSize: 16, fontWeight: 700, color, fontFamily: "'DM Sans', sans-serif" }}>{count}</div>
        <div style={{ fontSize: 11, color: C.textMuted, fontFamily: "'DM Sans', sans-serif" }}>{pct}%</div>
      </div>
    </div>
  );
};

/* ════════════════════════════════════════════════════════════════════════════
   MAIN
════════════════════════════════════════════════════════════════════════════ */
export const TeamLeaderQuickNumbersCRMData = () => {
  const theme    = useTheme();
  const mode     = theme.palette.mode;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const sidebarW = useSidebarWidth();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const [userlogin, setUserlogin] = useState(null);
  const [loading,   setLoading]   = useState(true);

  useEffect(() => {
    const u = localStorage.getItem('user');
    if (u) setUserlogin(JSON.parse(u));
  }, []);

  /* ── redux data ── */
  const dashboardData     = useSelector(s => s.AllRoleData.teamleaderdashboardcrmdata);
  const dashboard         = dashboardData?.data?.dashboard         || [];
  const teamLeaderFresh   = dashboardData?.data?.teamLeaderFresh   || { leadsCount: 0 };
  const teamLeaderPending = dashboardData?.data?.teamLeaderPending || { leadsCount: 0, salesIds: [] };
  const summary           = dashboardData?.data?.summary           || { totalLeads: 0 };
  const teamleaderInfo    = dashboardData?.data?.teamleaderInfo    || {};

  useEffect(() => {
    if (userlogin?.data?.email) {
      setLoading(true);
      dispatch(GetteamleaderdashboarddatabyteamleaderemailadvancedCRMDATA(userlogin.data.email))
        .finally(() => setLoading(false));
    }
  }, [userlogin, dispatch]);

  useEffect(() => { if (dashboardData) setLoading(false); }, [dashboardData]);

  /* ── sorted stages — same order as TeamLeaderDashboard ── */
  const STAGE_ORDER = ['Team Leader Pending','Team Leader Fresh','No Stage','Pending','Interested','Follow Up','Meeting','Follow After Meeting','Done Deal','Cancel Meeting','No Answer','Not Interested','Transfer','Long Follow','Follow','Following After Meeting','No Answer 1st Call','Cancellation'];

  const allStages = useMemo(() => {
    const regular = dashboard
      .filter(s => s.stageName !== 'Fresh' && s.stageName !== 'Team Leader Fresh' && s.stageName !== 'Team Leader Pending')
      .sort((a, b) => {
        const ia = STAGE_ORDER.indexOf(a.stageName), ib = STAGE_ORDER.indexOf(b.stageName);
        if (ia !== -1 && ib !== -1) return ia - ib;
        if (ia !== -1) return -1; if (ib !== -1) return 1; return 0;
      });
    return [
      { stageId: 'tl-pending', stageName: 'Team Leader Pending', leadsCount: teamLeaderPending.leadsCount, isTeamLeaderPending: true, salesIds: teamLeaderPending.salesIds || [] },
      { stageId: 'tl-fresh',   stageName: 'Team Leader Fresh',   leadsCount: teamLeaderFresh.leadsCount,   isTeamLeaderFresh: true },
      ...regular,
    ];
  }, [dashboard, teamLeaderFresh, teamLeaderPending]);

  const totalLeads = summary.totalLeads || 0;
  const doneDeals  = allStages.find(s => s.stageName === 'Done Deal')?.leadsCount || 0;
  const convRate   = totalLeads > 0 ? ((doneDeals / totalLeads) * 100).toFixed(1) : 0;

  /* ── stage click — same logic as TeamLeaderDashboard but routes to CRM pages ── */
  const handleStageClick = (stage) => {
    const keys = ['teamLeaderFreshMode','teamLeaderPendingMode','teamLeaderPendingSalesId','teamleaderfresh','teamleaderId','filterForSales','teamleaderpending','stagestorage','FilteredLeadsForNoStage','FilteredLeadsForTeamLeaderPending','freshFilterType','crmDataMode'];
    keys.forEach(k => localStorage.removeItem(k));
    localStorage.setItem('crmDataMode', 'true');

    const { stageName, isTeamLeaderFresh, isTeamLeaderPending, salesIds } = stage;
    const crmParams = { data: 'true', transferefromdata: 'false' };

    if (isTeamLeaderFresh) {
      const tlId = salesIds?.[0] || teamleaderInfo._id || userlogin?.data?._id || '';
      const q = new URLSearchParams({ stage: 'No Stage', sales: tlId, teamleaderfresh: 'true', freshmode: 'teamleader', ...crmParams });
      localStorage.setItem('stagestorage', 'No Stage');
      localStorage.setItem('filterForSales', tlId);
      localStorage.setItem('teamleaderId', tlId);
      localStorage.setItem('teamleaderfresh', 'true');
      localStorage.setItem('teamLeaderFreshMode', 'true');
      localStorage.setItem('freshFilterType', 'teamleader');
      navigate(`/TeamLeaderCRMDATAALLLeads?${q.toString()}`);

    } else if (isTeamLeaderPending) {
      const tlId = salesIds?.[0] || teamleaderInfo._id || userlogin?.data?._id || '';
      const q = new URLSearchParams({ stage: 'Pending', sales: tlId, teamleaderpending: 'true', pendingmode: 'teamleader', ...crmParams });
      localStorage.setItem('stagestorage', 'Pending');
      localStorage.setItem('teamleaderpending', 'true');
      localStorage.setItem('filterForSales', tlId);
      localStorage.setItem('teamLeaderPendingMode', 'true');
      localStorage.setItem('teamLeaderPendingSalesId', tlId);
      navigate(`/TeamLeaderCRMDATAALLLeads?${q.toString()}`);

    } else if (stageName === 'All Leads') {
      localStorage.setItem('stagestorage', '');
      navigate(`/TeamLeaderCRMDATAALLLeads?${new URLSearchParams(crmParams).toString()}`);

    } else {
      localStorage.setItem('stagestorage', stageName);
      const q = new URLSearchParams({ stage: encodeURIComponent(stageName), ...crmParams });
      navigate(`/TeamLeaderCRMDATAALLLeads?${q.toString()}`);
    }
  };

  /* ── chart ── */
  const chartData = useMemo(() => {
    const labels = allStages.map(s => s.stageName);
    const data   = allStages.map(s => s.leadsCount || 0);
    const colors = allStages.map(s => getStageColor(s.stageName));
    return {
      labels,
      datasets: [{ data, backgroundColor: colors, borderColor: mode === 'dark' ? '#1a1a2e' : '#fff', borderWidth: 2, hoverOffset: 12 }],
    };
  }, [allStages, mode]);

  const chartOptions = {
    responsive: true, maintainAspectRatio: false,
    plugins: {
      legend: { position: 'right', labels: { color: mode === 'dark' ? '#fff' : C.text, font: { size: 11, family: "'DM Sans', sans-serif" }, padding: 16, usePointStyle: true, pointStyle: 'circle' } },
      tooltip: {
        backgroundColor: C.white, titleColor: C.text, bodyColor: C.textMuted, borderColor: C.border, borderWidth: 1,
        callbacks: { label: ctx => { const t = ctx.dataset.data.reduce((a,b)=>a+b,0); return `${ctx.label}: ${ctx.raw} leads (${t>0?((ctx.raw/t)*100).toFixed(1):0}%)`; } },
      },
    },
    cutout: '62%',
  };

  /* ── loading ── */
  if (loading) return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh', background: C.bg }}>
      <div style={{ textAlign:'center' }}>
        <div style={{ width:48, height:48, borderRadius:'50%', border:`3px solid ${C.accentSoft}`, borderTop:`3px solid ${C.accent}`, animation:'spin 0.8s linear infinite', margin:'0 auto 16px' }} />
        <div style={{ fontSize:14, color:C.textMuted, fontFamily:"'DM Sans', sans-serif" }}>Loading CRM Dashboard...</div>
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    </div>
  );

  /* ── render ── */
  return (
    <div style={{
      marginLeft: isMobile ? SIDEBAR_COLLAPSED : sidebarW,
      marginTop: 64,
      minHeight: 'calc(100vh - 64px)',
      background: C.bg,
      transition: 'margin-left 0.25s cubic-bezier(0.4,0,0.2,1)',
      fontFamily: "'DM Sans', sans-serif",
    }}>
      <div style={{ padding: isMobile ? '16px' : '28px 28px 48px' }}>

        {/* ── Header ── */}
        <div style={{ display:'flex', alignItems:'flex-start', justifyContent:'space-between', flexWrap:'wrap', gap:16, marginBottom:28 }}>
          <div>
            {/* back button */}
            <button
              onClick={() => navigate('/TeamLeaderDashboard')}
              style={{ display:'flex', alignItems:'center', gap:6, padding:'6px 12px', borderRadius:8, border:`1px solid ${C.border}`, background:C.white, color:C.textMuted, fontSize:12, fontWeight:600, cursor:'pointer', fontFamily:"'DM Sans', sans-serif", marginBottom:12, transition:'all 0.15s' }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = C.accent; e.currentTarget.style.color = C.accent; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = C.border; e.currentTarget.style.color = C.textMuted; }}
            >
              <ArrowBackIcon sx={{ fontSize:14 }} />
              Back to Dashboard
            </button>

            <div style={{ fontSize: isMobile ? 28 : 36, fontWeight:800, color:C.text, lineHeight:1.15, letterSpacing:'-0.02em', fontFamily:"'DM Sans', sans-serif" }}>
              CRM Data<br />Dashboard
            </div>
            <div style={{ fontSize:13.5, color:C.textMuted, marginTop:8, fontFamily:"'DM Sans', sans-serif" }}>
              <span style={{ display:'inline-flex', alignItems:'center', gap:6, padding:'3px 10px', borderRadius:20, background: C.accentSoft, color: C.accent, fontSize:11, fontWeight:700, letterSpacing:'0.06em', textTransform:'uppercase', marginRight:8, fontFamily:"'DM Sans', sans-serif" }}>CRM Data</span>
              {teamleaderInfo.name || userlogin?.data?.name || 'Team Leader'} — data center pipeline.
              {dashboardData?.data?.meta && (
                <span style={{ marginLeft:8, fontSize:11, color:C.textMuted }}>
                  · {dashboardData.data.meta.executionTime} {dashboardData.data.meta.fromCache ? '(cached)' : '(fresh)'}
                </span>
              )}
            </div>
          </div>

          {/* Stat cards */}
          <div style={{ display:'flex', gap:12, flexWrap:'wrap', alignItems:'stretch' }}>
            <StatCard label="All CRM Leads"  value={totalLeads}                   onClick={() => handleStageClick({ stageName:'All Leads' })} />
            <StatCard label="CRM Pending"    value={teamLeaderPending.leadsCount} color={C.warning} highlight onClick={() => handleStageClick({ stageName:'Team Leader Pending', isTeamLeaderPending:true, salesIds:teamLeaderPending.salesIds })} />
            <StatCard label="CRM Fresh"      value={teamLeaderFresh.leadsCount}   color={C.accent}  highlight onClick={() => handleStageClick({ stageName:'Team Leader Fresh', isTeamLeaderFresh:true })} />
            <StatCard label="Conv. Rate"     value={`${convRate}%`} highlight />
          </div>
        </div>

        {/* ── Toolbar ── */}
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:20, flexWrap:'wrap', gap:8 }}>
          <div style={{ display:'flex', alignItems:'center', gap:8 }}>
            <ShowChartIcon sx={{ color:C.accent, fontSize:18 }} />
            <span style={{ fontSize:16, fontWeight:700, color:C.text, fontFamily:"'DM Sans', sans-serif" }}>CRM Data Stages</span>
            <span style={{ fontSize:12, color:C.textMuted, fontFamily:"'DM Sans', sans-serif" }}>({allStages.length}) — click any card to view leads</span>
          </div>
        </div>

        {/* ── Stage cards grid — same layout as TeamLeaderDashboard ── */}
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(160px, 1fr))', gap:12, marginBottom:28 }}>
          {allStages.map(stage => (
            <StageCard
              key={stage.stageId || stage.stageName}
              stage={stage}
              totalLeads={totalLeads}
              onStageClick={handleStageClick}
            />
          ))}
        </div>

        {/* ── Chart + List row — same as TeamLeaderDashboard ── */}
        <div style={{ display:'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap:16, marginBottom:28 }}>

          {/* Doughnut */}
          <div style={{ background:C.white, border:`1px solid ${C.border}`, borderRadius:12, boxShadow:C.shadow, overflow:'hidden' }}>
            <div style={{ padding:'20px 22px 16px', borderBottom:`1px solid ${C.border}` }}>
              <div style={{ fontSize:15, fontWeight:700, color:C.text, fontFamily:"'DM Sans', sans-serif" }}>
                <BarChartIcon sx={{ fontSize:17, color:C.accent, verticalAlign:'middle', mr:0.5 }} />
                CRM Distribution
              </div>
              <div style={{ fontSize:12, color:C.textMuted, fontFamily:"'DM Sans', sans-serif", marginTop:3 }}>Visual breakdown across all CRM stages</div>
            </div>
            <div style={{ padding:'20px 22px', height:320 }}>
              <Doughnut data={chartData} options={chartOptions} />
            </div>
          </div>

          {/* Stages list */}
          <div style={{ background:C.white, border:`1px solid ${C.border}`, borderRadius:12, boxShadow:C.shadow, overflow:'hidden' }}>
            <div style={{ padding:'20px 22px 16px', borderBottom:`1px solid ${C.border}` }}>
              <div style={{ fontSize:15, fontWeight:700, color:C.text, fontFamily:"'DM Sans', sans-serif" }}>
                <BookmarkIcon sx={{ fontSize:17, color:C.accent, verticalAlign:'middle', mr:0.5 }} />
                CRM Stages Overview
              </div>
              <div style={{ fontSize:12, color:C.textMuted, fontFamily:"'DM Sans', sans-serif", marginTop:3 }}>Click any stage to view CRM leads</div>
            </div>
            <div style={{ padding:'16px 22px', maxHeight:320, overflowY:'auto' }}>
              {allStages.map(stage => (
                <StageRow
                  key={stage.stageId || stage.stageName}
                  stage={stage}
                  totalLeads={totalLeads}
                  onStageClick={handleStageClick}
                />
              ))}
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};
